import { Flex } from "styled-system/jsx";
import { Switch, Text } from "@ttc3k/trekker";

type OrgSettingsToggleProps = {
  title: string;
  description?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  isSaving: boolean;
  disabled?: boolean;
};

export const OrgSettingsToggle = ({
  title,
  description,
  checked,
  onCheckedChange,
  isSaving,
  disabled,
}: OrgSettingsToggleProps) => (
  <Flex alignItems="center" justifyContent="space-between" gap="500">
    <Flex flexDir="column" gap="100">
      <Text visual="bodySemiBold">{title}</Text>
      {description ? (
        <Text visual="smallRegular" color="text.mid">
          {description}
        </Text>
      ) : null}
    </Flex>
    <Switch
      checked={checked}
      onCheckedChange={details => onCheckedChange(details.checked)}
      disabled={isSaving || disabled}
    />
  </Flex>
);
